import poker from "../contracts/Poker.json";
import {ChainId, web3} from "./Config";
import {AbiItem} from "web3-utils";
import {Contract} from "web3-eth-contract";

let contract: Contract;
export async function getContract() {
	if (!contract) {
		const networkId = ChainId;
		// @ts-ignore
		const network = poker.networks[networkId];
		contract = new web3.eth.Contract(
			poker.abi as AbiItem[],
			network && network.address
		);
		console.log("== contract ==", {contract, networkId, network});
	}
	return contract;
}
